import { useMemo, useState } from "react";

import { useWizardTranslation } from "@/libs/i18n/use-wizard-translation";

import { useCruiseContext } from "../../provider/cruise.provider";
import { getSingleOptionItem } from "../../utils/cruise.utils";

export function useFormContentToggle(
  setSelectedAnswer: (answer: 0 | 1 | 2) => void
) {
  const { selectedAnswer } = useCruiseContext();
  const [isKeyBoardFocused, setIsKeyBoardFocused] = useState(true);
  const { t } = useWizardTranslation();

  const handleClick = (id: 0 | 1 | 2) => {
    const isSelected = selectedAnswer === id;
    setSelectedAnswer(isSelected ? 0 : id);
  };

  const handleOnPressStart = (e: { pointerType: string }) => {
    if (e.pointerType === "keyboard") {
      setIsKeyBoardFocused(true);
    } else {
      setIsKeyBoardFocused(false);
    }
  };

  const toggleButtonOptions = useMemo(
    () => [
      getSingleOptionItem(1, selectedAnswer, t),
      getSingleOptionItem(2, selectedAnswer, t),
    ],

    [selectedAnswer]
  );

  return {
    isKeyBoardFocused,
    setIsKeyBoardFocused,
    handleClick,
    handleOnPressStart,
    toggleButtonOptions,
  };
}
